import { render, staticRenderFns } from "./DonorSerology.vue?vue&type=template&id=70947fc6"
import script from "./DonorSerology.vue?vue&type=script&lang=js"
export * from "./DonorSerology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports